::ng-deep app-download-memo-cell-viewer .grid-mini-button-container .grid-mini-button{padding-inline:5px}
/*# sourceMappingURL=download-memo-cell-viewer.component-IHO2DFGE.css.map */
